import { createI18n } from 'vue-i18n';
import { I18nHelpers } from '@/helpers/i18n';

const appLocale = I18nHelpers.getAppLocale();

const i18n = createI18n({
    legacy: false,
    locale: appLocale,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    globalInjection: true,
    messages: {},
    messageCompiler: (msg: string) => {
        const safe = msg.replace(/@/g, '\\@');
        return () => safe.replace(/\\@/g, '@');
    },
});

export async function loadLocaleMessagesAsync(locale: string) {
    if (!i18n.global.availableLocales.includes(locale)) {
        const msgs = await import(`@/locales/${locale}.json`);
        i18n.global.setLocaleMessage(locale, msgs.default);
    }
    i18n.global.locale.value = locale;
    return locale;
}

export default i18n;
